import React from "react";
import 'normalize.css';

import {Link} from 'react-router-dom';
// import ContactUs from "./Components/ContactUs"
export default function Header(){
    return(
        <header className="main-header main-header-overlay">

    <div class="mainbar-wrap">
                <div className="megamenu-hover-bg"></div>
                <div className="container-fluid mainbar-container">
                    <div className="mainbar">
                        <div className="row mainbar-row align-items-lg-stretch px-4">
                            <div className="col">
                                <div className="navbar-header">
                                    <a className="navbar-brand"  rel="home">
                                        <span className="navbar-brand-inner">
                                        <img className="logo-dark" src="assets/img/logo/DocBoyz153.png" alt="Creintech Solutions"></img>
                                        <img className="logo-sticky" src="assets/img/logo/DocBoyz153.png" alt="Creintech Solutions"></img>
                                        {/* <img className="mobile-logo-default" src="assets/img/logo/creintech-mobile-logo.png" alt="Creintech Solutions"></img> */}
                                        {/* <h1 className="text-white pr-md-5 mt-0 mb-40" data-split-text="true" data-split-options={{ "type":"lines" }}>DocBoyz </h1> */}
                                        {/* <img className="logo-default" src="assets/img/logo/DocBoyz153.png" alt="Creintech Solutions"></img> */}
                                        {/* <img className="logo-default" src="assets/img/logo/DocBoyz.png" alt="Creintech Solutions" style={{ width: '60px', height: 'auto' }} /> */}
                                        
                                        <img className="logo-default" src="assets/img/logo/New.png" alt="Creintech Solutions" style={{ width: '70px', height: '70px', marginBottom: '25px' }} />
                                        <span className="navbar-brand-inner">
                                        <h1 style={{ fontSize: '3em', fontWeight: 'bold' }}>
                                          <span style={{ color: 'red', fontWeight: 'bold' }}>Doc</span>
                                          <span style={{ color: 'white', fontWeight: 'bold' }}>Boyz</span>
                                        </h1>
                                        </span>
                                    </span>
                                    </a>
                                    <button type="button" className="navbar-toggle collapsed nav-trigger style-mobile" data-toggle="collapse" data-target="#main-header-collapse" aria-expanded="false" data-changeclassNamenames='{ "html": "mobile-nav-activated overflow-hidden" }'>
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="bars">
                                            <span className="bar"></span>
                                            <span className="bar"></span>
                                            <span className="bar"></span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div className="col text-right">
                                <div className="collapse navbar-collapse" id="main-header-collapse" aria-expanded="false" role="tablist">                                   
                                    <ul className="main-nav main-nav-hover-underline-1 nav align-items-lg-stretch justify-content-lg-end">
                                        <li>
                                        <Link to="/">
                                                <span className="link-icon"></span>
                                                <span className="link-txt">
                                                    <span className="link-ext"></span>
                                                    <span className="txt">Home</span>
                                                </span>
                                                </Link>
                                        </li>
                                        <li>
                                            <Link to="/CompanyPage">
                                                <span className="link-icon"></span>
                                                <span className="link-txt">
                                                    <span className="link-ext"></span>
                                                    <span className="txt">Company</span>
                                                </span>
                                            </Link>
                                        </li>
                                        <li className="menu-item-has-children megamenu megamenu-fullwidth">
                                        <Link to="/CollectKart">
                                      
                                            <span className="link-icon"></span>
                                            <span className="link-txt">
                                                <span className="link-ext"></span>
                                                <span className="txt">
                                                    {/* Services */}
                                                    Collect Kart
                                                    <span className="submenu-expander">
                                                        <i className="fa fa-angle-down"></i>
                                                    </span>
                                                </span>
                                            </span>
                                        
                                        </Link>
                                        <ul className="nav-item-children">
                                            <li>
                                                <div className="container megamenu-container">
                                                    <div className="vc_row row megamenu-inner-row bg-white">
                                                        <div className="container ld-container">
                                                            <div className="row ld-row">
                                                                <ul className="lqd-custom-menu reset-ul">
                                                                        <li><Link to="/CollectKart">DB Document Collection</Link></li>
                                                                        <li><Link to="/DebtRecovery">DB Debt Recovery</Link></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                        <li>
                                        <Link to="/Careers">
                                            {/* <a href="#" target="_blank"> */}
                                                <span className="link-icon"></span>
                                                <span className="link-txt">
                                                    <span className="link-ext"></span>
                                                    <span className="txt">Careers</span>
                                                </span>
                                                </Link>
                                            {/* </a> */}
                                        </li>
                                        <li>
                                           <Link to="/Login">
                                                <span className="link-icon"></span>
                                                <span className="link-txt">
                                                    <span className="link-ext"></span>
                                                    <span className="txt">Login</span>
                                                </span>
                                                </Link>
                                        </li>
                                        <li>
                                        <Link to="/ContactUs">
                                                <span className="link-icon"></span>
                                                <span className="link-txt">
                                                    <span className="link-ext"></span>
                                                    <span className="txt">Contact</span>
                                                </span>
                                                </Link>
                                        </li>
                                    </ul>                                   
                                </div>
                                <div className="header-module">
                                <a  className="btn btn-solid btn-sm round btn-solid border-thick btn-gradient color-primary font-size-14">
                                    <span>
                                        <span className="btn-gradient-bg"></span>
                                        <strong style={{ fontSize: "17px" }}><span className="btn-txt"><Link to="/CollectKart" >Document Verification</Link></span></strong>
                                        <span className="btn-gradient-bg btn-gradient-bg-hover"></span>
                                        <svg className="btn-gradient-border" width="100%" height="100%">
                                            <defs>
                                                <linearGradient id="svg-border-5c594d6934526" x1="0%" y1="0%" x2="100%" y2="0%">
                                                    <stop offset="0%" style={{ stopColor: "#ed3402" }}></stop>
                                                    <stop offset="100%" style={{ stopColor: "#e05b03" }}></stop>
                                                </linearGradient>
                                            </defs>
                                            <rect x="0.5" y="0.5" rx="4px" ry="4px" width="100%" height="100%" stroke="url(#svg-border-5c594d6934526)"></rect>
                                        </svg>
                                    </span>
                                </a>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </header>
    );
}